/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useContext } from 'react';

import { useDispatch } from 'react-redux';
import { selectTailTagsShown } from '../../../store';
import { MapActionsContext, useSelectorWithMapId } from '../map/BaseMapContainer';
import OverlayToggle from './OverlayToggle';

const TailTagsOverlay = () => {
  const dispatch = useDispatch();
  const mapActionsContext = useContext(MapActionsContext);

  const tailTagsShown = useSelectorWithMapId(selectTailTagsShown);
  const { setTailTagsShown } = mapActionsContext.mapActions;

  return (
    <OverlayToggle
      checked={tailTagsShown}
      setChecked={() => {
        dispatch(setTailTagsShown(!tailTagsShown));
      }}
      toggleId="tailTagsSwitch"
      label="Tail Tags"
    />
  );
};

export default TailTagsOverlay;
